import React from "react";

const InvoiceViewer = ({ base64Data }) => {
  return (
    <html>
      <head>
        <title>Invoice</title>
        <style>
          {`
            body, html { margin: 0; padding: 0; height: 100%; }
            iframe { width: 100%; height: 100%; border: none; }
          `}
        </style>
      </head>
      <body>
        <iframe src={`data:application/pdf;base64,${base64Data}`}></iframe>
      </body>
    </html>
  );
};

export default InvoiceViewer;
